import React from 'react';
import PropTypes from 'prop-types';

import { MPopupHeader } from '../../molecules/MPopupHeader';
import PopupOfferActionButtons from '../../molecules/PopupOfferActionButtons';
import { MBox } from '../../atoms/MBox';
import MFlexbox from '../../atoms/MFlexbox';
import { MText } from '../../atoms/MText';
import PriceDetails from '../../molecules/PriceDetails';
import { MDiscountCode } from '../../MDiscountCode';

export default function PopupBundleOfferCon(props) {
  const {
    // isMobile,
    // renderInCarousel,
    popupOfferHeaderStyles,
    popupOfferBottomBarStyles: {
      bottomBarContainerBackgroundColor,
      bottomBarContainerPadding,
      bottomBarContainerMargin,
      carouselActionColor,
      ...restPopupOfferBottomBarStyles
    },
    priceDetailStyles,
    bundlePriceBarInfo,
    onMinimizeClick,
    onCheckoutClick,
    // onSkipClick,
    children,
    productsContainerPadding,
    productsContainerMargin,
    showDiscountCode,
    discountCodeProps,
    isBottomBarButtonActionLoading,
  } = props;

  return (
    <>
      <MPopupHeader
        {...popupOfferHeaderStyles}
        onMinimizeClick={onMinimizeClick}
      />
      <MBox
        backgroundColor={bottomBarContainerBackgroundColor}
        padding={productsContainerPadding}
        margin={productsContainerMargin}
        className="mr-popup-widget__products-container"
      >
        {children}
      </MBox>
      <MBox
        backgroundColor={bottomBarContainerBackgroundColor}
        padding={bottomBarContainerPadding}
        margin={bottomBarContainerMargin}
        className="mr-popup-widget__bottom-bar-con"
      >
        {showDiscountCode && <MDiscountCode isBundled {...discountCodeProps} />}
        <MFlexbox
          gap="4px"
          ai="center"
          flexWrap="wrap"
          className="mr-bundle-total-con"
          backgroundColor={
            restPopupOfferBottomBarStyles.bundlePriceBarBackgroundColor
          }
          borderRadius={
            restPopupOfferBottomBarStyles.bundlePriceBarBorderRadius
          }
          padding={restPopupOfferBottomBarStyles.bundleTaglinePadding}
          margin={restPopupOfferBottomBarStyles.bundleTaglineMargin}
          jc={restPopupOfferBottomBarStyles.bundleTaglineTextAlignment}
        >
          <MText
            fontSize={restPopupOfferBottomBarStyles.bundleTaglineFontSize}
            mobileFontSize={
              restPopupOfferBottomBarStyles.bundleTaglineMobileFontSize
            }
            color={restPopupOfferBottomBarStyles.bundleTaglineTextColor}
            fontStyle={restPopupOfferBottomBarStyles.bundleTaglineFontStyle}
            fontWeight={restPopupOfferBottomBarStyles.bundleTaglineFontWeight}
            textDecoration={
              restPopupOfferBottomBarStyles.bundleTaglineTextDecoration
            }
            fontFamily={restPopupOfferBottomBarStyles.bundleTaglineFontFamily}
            className="mr-bundle-total-con__text"
          >
            {bundlePriceBarInfo.tagline}
          </MText>
          <PriceDetails
            offerPrice={bundlePriceBarInfo.offerPrice}
            price={bundlePriceBarInfo.price}
            off={bundlePriceBarInfo.off}
            isDiscountDisabled={bundlePriceBarInfo.isDiscountDisabled}
            {...priceDetailStyles}
            fontFamily={restPopupOfferBottomBarStyles.bundleTaglineFontFamily}
            className="mr-bundle-total-con__price"
          />
        </MFlexbox>
        <PopupOfferActionButtons
          layout="vertical"
          showSkipButton={false}
          showShoppingCartIcon
          onPrimaryClick={onCheckoutClick}
          isBottomBarButtonActionLoading={isBottomBarButtonActionLoading}
          {...restPopupOfferBottomBarStyles}
          //   onSecondaryClick={onSkipClick}
        />
      </MBox>
    </>
  );
}

PopupBundleOfferCon.propTypes = {
  children: PropTypes.node,
  popupOfferHeaderStyles: PropTypes.object,
  popupOfferBottomBarStyles: PropTypes.object,
  priceDetailStyles: PropTypes.object,
  bundlePriceBarInfo: PropTypes.object,
  onMinimizeClick: PropTypes.func,
  onCheckoutClick: PropTypes.func,
  productsContainerPadding: PropTypes.string,
  productsContainerMargin: PropTypes.string,
  showDiscountCode: PropTypes.bool,
  discountCodeProps: PropTypes.object,
  isBottomBarButtonActionLoading: PropTypes.bool,
};
